var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealestate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15.625V7.5L16.25 3.125L10 7.5V9.375H7.5V6.25L16.25 0L25 6.25V15.625H22.5ZM16.875 8.125H18.125V6.875H16.875V8.125ZM14.375 8.125H15.625V6.875H14.375V8.125ZM16.875 10.625H18.125V9.375H16.875V10.625ZM14.375 10.625H15.625V9.375H14.375V10.625ZM7.5 21.25L16.1875 23.625L23.625 21.3125C23.5208 21.125 23.3698 20.9635 23.1719 20.8281C22.974 20.6927 22.75 20.625 22.5 20.625H16.1875C15.625 20.625 15.1771 20.6042 14.8438 20.5625C14.5104 20.5208 14.1667 20.4375 13.8125 20.3125L10.9062 19.3438L11.5938 16.9062L14.125 17.75C14.4792 17.8542 14.8958 17.9375 15.375 18C15.8542 18.0625 16.5625 18.1042 17.5 18.125C17.5 17.8958 17.4323 17.6771 17.2969 17.4688C17.1615 17.2604 17 17.125 16.8125 17.0625L9.5 14.375H7.5V21.25ZM0 25.625V11.875H9.5C9.64583 11.875 9.79167 11.8906 9.9375 11.9219C10.0833 11.9531 10.2188 11.9896 10.3438 12.0312L17.6875 14.75C18.375 15 18.9323 15.4375 19.3594 16.0625C19.7865 16.6875 20 17.375 20 18.125H22.5C23.5417 18.125 24.4271 18.4688 25.1562 19.1562C25.8854 19.8438 26.25 20.75 26.25 21.875V23.125L16.25 26.25L7.5 23.8125V25.625H0ZM2.5 23.125H5V14.375H2.5V23.125Z",
    fill: "#655D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestate);
export default __webpack_public_path__ + "static/media/realestate.9006f0a5566e34d10199fbc97614ecaa.svg";
export { ForwardRef as ReactComponent };